'use client';

import type { MutableRefObject } from 'react';
import { useEffect } from 'react';
import { useFlights } from '@/data/sources/flights';
import type { FlightState } from './geo';
import { updateSky } from './skyStore';

const NO_FLIGHTS: FlightState[] = [];

export const useSkyData = (
  worker: Worker | null,
  workerRef: MutableRefObject<Worker | null>
): { flights: FlightState[] } => {
  const flights = useFlights().data ?? NO_FLIGHTS;

  useEffect(() => {
    updateSky({ flights });
    workerRef.current?.postMessage({ type: 'sky-state', state: { flights } });
  }, [flights, worker, workerRef]);

  return { flights };
};
